import _ from 'underscore';
import { Base } from './Base';

// Because we want to be able to chain the isEqualTo method from a subclass, we
// need to be able to directly reference the isValid() method for our objects
// here.
//
// In javascript, this.foo() resolves in the context of the child, even when called via super.
// i.e., super.isEqualTo() called from FilePlusArrayBase means that
//       this.isValid() would call the method in arraybase, not the one in this class.
function fileIsValid(v) {
  return v.uploaded && _.isObject(v.uploaded);
}

export class FileBase extends Base {
  uploaded = null;

  isValid() {
    return fileIsValid(this);
  }

  isEqualTo(other) {
    // Both point to the same file path
    return (
      (!fileIsValid(this) && !fileIsValid(other)) ||
      (!!this.uploaded && !!other.uploaded && this.uploaded.path === other.uploaded.path)
    );
  }
}
